import { useState } from 'react';
import { usePlacingPayment } from 'contexts/placingPayment';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const EmailContainer = styled.div`
  margin-top: 20px;
  padding: 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`;

const Description = styled(Typography)`
  && {
    font-size: 12px;
    color: #666;
    margin-bottom: 12px;
  }
`;

const StyledTextField = styled(TextField)`
  && {
    width: 100%;
    .MuiOutlinedInput-root {
      border-radius: 8px;
      background: #fafafa;
    }
    .MuiInputLabel-outlined {
      font-size: 14px;
    }
  }
`;

const BuyerEmailInput = () => {
  const { paymentInfo, setPaymentInfo } = usePlacingPayment();
  const [email, setEmail] = useState(paymentInfo.buyerEmail || '');
  const [error, setError] = useState('');

  if (!paymentInfo.emailEnableBuyer) {
    return null;
  }

  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (value && !validateEmail(value)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein');
    } else {
      setError('');
    }

    setPaymentInfo({
      ...paymentInfo,
      buyerEmail: value,
    });
  };

  return (
    <EmailContainer>
      <Description>
        Geben Sie Ihre E-Mail-Adresse ein, um eine Zahlungsbestätigung zu erhalten.
      </Description>
      <StyledTextField
        variant="outlined"
        size="small"
        label="E-Mail für Quittung"
        placeholder="ihre@email.de"
        value={email}
        onChange={handleChange}
        error={!!error}
        helperText={error}
        type="email"
        inputProps={{ autoComplete: 'email' }}
      />
    </EmailContainer>
  );
};

export default BuyerEmailInput;
